import React, {
    createContext,
    useContext,
    useState,
    ReactNode,
    Dispatch,
    SetStateAction,
  } from "react";
  
  interface CheckListContextType {
    checkList: string;
    setCheckList:Dispatch<SetStateAction<any>>;
  }
  
  const CheckListContext = createContext<
  CheckListContextType | undefined
  >(undefined);
  
  export const useCheckListContext = () =>
    useContext(
        CheckListContext,
    ) as CheckListContextType;
  
  export const CheckListContextProvider: React.FC<{
    children: ReactNode;
  }> = ({ children }) => {
    const [checkList, setCheckList] = useState<string>("");

  
    const contextValues: CheckListContextType = {
      checkList,
      setCheckList,
    };
  
    return (
      <CheckListContext.Provider value={contextValues}>
        {children}
      </CheckListContext.Provider>
    );
  };
  